import { DoubleAngleBracketIcon as Arrow } from "assets/svgs/icon";
import cx from "classnames";
import { useState } from "react";
import styles from "style/pages/market/previewSidebar/sidebarLayout.module.scss";
import SidebarErrorBoundary from "./SidebarErrorBoundary";

type TSidebarProps = {
  defaultOpen?: boolean;
  children: React.ReactNode;
  getIsOpen?: (isOpen: boolean) => void;
};

export default function SidebarLayout({ children, getIsOpen, defaultOpen = true }: TSidebarProps) {
  const [isOpen, setIsOpen] = useState(defaultOpen);
  const handleSidebar = () => {
    getIsOpen && getIsOpen(!isOpen);
    setIsOpen((prev) => !prev);
  };

  return (
    <div className={cx(styles.wrapper, { [styles.wrapperOpen]: isOpen })}>
      <button type="button" className={cx(styles.sidebarOpenBtn)} onClick={handleSidebar}>
        <Arrow className={cx({ [styles.closeArrow]: isOpen })} />
      </button>
      <SidebarErrorBoundary>
        <div className={styles.innerWrapper}>{children}</div>
      </SidebarErrorBoundary>
    </div>
  );
}
